import { Suspense, lazy, useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { Flex, Box, useColorModeValue } from "@chakra-ui/react";
import Sidebar from "./components/Sidebar";
import { Loading } from "./components";
import TestPage from "./pages/TestPage";

const NotFound = lazy(() => import("./pages/NotFound"));
const NoPermission = lazy(() => import("./pages/NoPermission"));
const Splash = lazy(() => import("./pages/Splash"));
const Login = lazy(() => import("./pages/Login"));
const Register = lazy(() => import("./pages/Register"));
const ForgotPass = lazy(() => import("./pages/ForgotPass"));
const Home = lazy(() => import("./pages/Home"));
const Kasbon = lazy(() => import("./pages/Kasbon"));
const Pengeluaran = lazy(() => import("./pages/Pengeluaran"));
const ManajemenPengguna = lazy(() => import("./pages/ManajemenPengguna"));
const Profile = lazy(() => import("./pages/Profile"));

const FbSuspense = () => (
  <Flex
    alignItems="center"
    justifyContent="center"
    py={10}
    px={6}
    minH="calc(100vh - 2rem)"
  >
    <Loading />
  </Flex>
);

export const MainLoading = () => (
  <Box p="4" minH="100vh" bg={useColorModeValue("gray.50", "blackAlpha.700")}>
    <FbSuspense />
  </Box>
);

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  if (loading) {
    return <MainLoading />;
  }

  return (
    <Sidebar>
      <Suspense fallback={<FbSuspense />}>
        <Routes>
          <Route path="*" element={<NotFound />} />
          <Route path="/403" element={<NoPermission />} />
          <Route path="/auth" element={<Splash />} />
          <Route path="/auth/login" element={<Login />} />
          <Route path="/auth/register" element={<Register />} />
          <Route path="/auth/forgot-password" element={<ForgotPass />} />
          <Route path="/" element={<Home />} />
          <Route path="kasbon" element={<Kasbon />} />
          <Route path="pengeluaran" element={<Pengeluaran />} />
          <Route path="manajemen-pengguna" element={<ManajemenPengguna />} />
          <Route path="profile" element={<Profile />} />
          <Route path="testpage" element={<TestPage />} />
        </Routes>
      </Suspense>
    </Sidebar>
  );
}

export default App;
